export function toUTC(date) {
    if (!date.getDate) {
        date = new Date(date);
    }
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
}

export function fromUTC(date) {
    if (!date.getDate) {
        date = new Date(date);
    }
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}

const getTimezoneOffset = value => value.getTimezoneOffset() * 60000;

export const makeLocalAppearUTC = (value) => {
    const dateTime = new Date(value);
    const utcFromLocal = new Date(dateTime.getTime() + getTimezoneOffset(dateTime));
    return utcFromLocal;
};

export const localToUTC = (dateTime) => {
    const utcFromLocal = new Date(dateTime.getTime() - getTimezoneOffset(dateTime));
    return utcFromLocal;
};



// WEBPACK FOOTER //
// ./app/helpers/dates.js